import React from 'react';
import { DocumentIcon } from '@heroicons/react/24/outline';
import { formatBytes } from '../../utils/formatBytes';
import type { DocumentMessageMetadata } from '../../contexts/ChatInDocContext';

function statusLabel(processingStatus: string): string {
  const s = (processingStatus || '').toLowerCase();
  if (s === 'pending') return 'Pendente';
  if (s === 'processing') return 'Indexando';
  if (s === 'completed') return 'Indexado';
  if (s === 'failed') return 'Falhou';
  return processingStatus;
}

function statusClass(processingStatus: string): string {
  const s = (processingStatus || '').toLowerCase();
  if (s === 'completed') return 'bg-emerald-500/20 text-emerald-100';
  if (s === 'failed') return 'bg-red-500/20 text-red-100';
  if (s === 'processing') return 'bg-amber-500/20 text-amber-100';
  return 'bg-white/15 text-blue-100';
}

export interface DocumentMessageBubbleProps {
  metadata: DocumentMessageMetadata;
  variant: 'user' | 'assistant';
}

export const DocumentMessageBubble: React.FC<DocumentMessageBubbleProps> = ({ metadata, variant }) => {
  const isUser = variant === 'user';
  const sub = isUser ? 'text-blue-100' : 'text-gray-500';
  const iconBg = isUser ? 'bg-white/15' : 'bg-gray-100';

  return (
    <div className="flex items-start gap-3 min-w-0">
      <div className={`flex-shrink-0 rounded-lg p-2 ${iconBg}`}>
        <DocumentIcon className={`h-6 w-6 ${isUser ? 'text-white' : 'text-gray-600'}`} />
      </div>
      <div className="min-w-0 flex-1">
        <div className={`font-medium truncate ${isUser ? 'text-white' : 'text-gray-900'}`}>
          {metadata.fileName || 'Documento'}
        </div>
        <div className={`text-xs mt-0.5 ${sub}`}>
          {formatBytes(metadata.fileSizeBytes)}
          {metadata.fileType ? ` · ${metadata.fileType}` : ''}
        </div>
        <div className="mt-2">
          <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${statusClass(metadata.processingStatus)}`}
          >
            {statusLabel(metadata.processingStatus)}
          </span>
        </div>
      </div>
    </div>
  );
};
